import { apiClient } from '@/lib/api-client';

/** Uma opção do autocomplete — o `userId` é o que vai como filtro pro Sales. */
export interface ContactOption {
  userId: string;
  name: string;
  email: string | null;
}

interface ContactSearchResponse {
  items: ContactOption[];
}

/**
 * Busca de contato do Identity (`GET /admin/identity/contacts`): um único
 * `filter` que casa nome **ou** email parcial, não paginado.
 *
 * Vive em `shared/` e não num módulo porque serve tanto Vendas quanto
 * Contratos — e é justamente o que permite filtrar por contato sem o módulo
 * `sales` do backend conhecer o `identity`: quem resolve "texto → userId" é o
 * front.
 *
 * Instanciada uma única vez abaixo — o consumidor usa o singleton.
 */
class ContactsApiDatasource {
  async searchContacts(filter: string): Promise<ContactOption[]> {
    const { data } = await apiClient.get<ContactSearchResponse>(
      '/admin/identity/contacts',
      { params: { filter } },
    );
    return data.items;
  }
}

export const contactsApiDatasource = new ContactsApiDatasource();
